import React, { useState } from "react";

import ecom1 from "../../assets/internalImages/Enterprise/_iws_e_commerce_1.webp";
import ecom2 from "../../assets/internalImages/Enterprise/_iws_e_commerce_2.webp";
import ecom3 from "../../assets/internalImages/Enterprise/_iws_e_commerce_3.webp";

import processed1 from "../../assets/internalImages/Enterprise/_iws_fresh_processed_foods_1.webp";
import processed2 from "../../assets/internalImages/Enterprise/_iws_fresh_processed_foods_2.webp";
import processed3 from "../../assets/internalImages/Enterprise/_iws_fresh_processed_foods_3.webp";

import electro1 from "../../assets/internalImages/Enterprise/_iws_electronics_gadgets_1.webp";
import electro2 from "../../assets/internalImages/Enterprise/_iws_electronics_gadgets_2.webp";
import electro3 from "../../assets/internalImages/Enterprise/_iws_electronics_gadgets_3.webp";

import fmcg1 from "../../assets/internalImages/Enterprise/_iws_fmcg_1.webp";
import fmcg2 from "../../assets/internalImages/Enterprise/_iws_fmcg_2.webp";
import fmcg3 from "../../assets/internalImages/Enterprise/_iws_fmcg_3.webp";

import const1 from "../../assets/internalImages/Enterprise/_iws_construction_supplies_1.webp";
import const2 from "../../assets/internalImages/Enterprise/_iws_construction_supplies_2.webp";
import const3 from "../../assets/internalImages/Enterprise/_iws_construction_supplies_3.webp";

import furni1 from "../../assets/internalImages/Enterprise/_iws_furniture_1.webp";
import furni2 from "../../assets/internalImages/Enterprise/_iws_furniture_2.webp";
import furni3 from "../../assets/internalImages/Enterprise/_iws_furniture_3.webp";

import pharma1 from "../../assets/internalImages/Enterprise/_iws_pharma_cemicals_1.webp";
import pharma2 from "../../assets/internalImages/Enterprise/_iws_pharma_cemicals_2.webp";
import pharma3 from "../../assets/internalImages/Enterprise/_iws_pharma_cemicals_3.webp";

import log1 from "../../assets/internalImages/Enterprise/_iws_logistics_1.webp";
import log2 from "../../assets/internalImages/Enterprise/_iws_logistics_2.webp";
import log3 from "../../assets/internalImages/Enterprise/_iws_logistics_3.webp";

import Grid from "../../assets/Grid.png";

const industriesData = [
  {
    name: "E-COMMERCE BRANDS",
    content: "We streamline e-commerce logistics from warehouse to doorstep.",
    images: [ecom1, ecom2, ecom3],
  },
  {
    name: "FRESH & PROCESSED FOODS",
    content: "Temperature-controlled and timely food deliveries ensured.",
    images: [processed1, processed2, processed3],
  },
  {
    name: "ELECTRONICS & GADGETS",
    content: `From smartphones and laptops to home appliances and accessories, we help manufacturers, distributors, and retailers deliver high-value, fragile electronic goods with care. Our logistics solutions ensure anti-shock handling, secure packaging compatibility, and timely deliveries across urban and semi-urban markets. Whether it's single-unit last-mile delivery or bulk movement between warehouses, Packky (powered by Chaafo) ensures safety and efficiency.`,
    images: [electro1, electro2, electro3],
  },
  {
    name: "FMCG GOODS",
    content: "Fast-moving consumer goods, delivered rapidly and reliably.",
    images: [fmcg1, fmcg2, fmcg3],
  },
  {
    name: "CONSTRUCTION SUPPLIES",
    content: "Heavy-load materials delivered to the right site at the right time.",
    images: [const1, const2, const3],
  },
  {
    name: "FURNITURES",
    content: "Bulky and delicate items handled with care in every delivery.",
    images: [furni1, furni2, furni3],
  },
  {
    name: "PHARMA & CHEMICALS",
    content: "Secure and temperature-sensitive pharma deliveries managed.",
    images: [pharma1, pharma2, pharma3],
  },
  {
    name: "LOGISTICS",
    content: "Full-suite logistics solutions for various business sizes.",
    images: [log1, log2, log3],
  },
];

const IndustriesWeServe = () => {
  const [selected, setSelected] = useState("ELECTRONICS & GADGETS");

  const selectedIndustry = industriesData.find(
    (industry) => industry.name === selected
  );

  return (
    <div
      className="py-5"
      style={{ backgroundImage: `url(${Grid})` }}
    >
      <div className="container my-5">
        {/* Header */}
        <div className="text-center mb-4">
          <h2 className="fw-100">Industries We Serve</h2>
          <p className="text-secondary fw-100">
            Serving diverse industries with fast, reliable, and scalable delivery.
          </p>
        </div>

        {/* Category Tabs */}
<div className="category-tabs">
  {industriesData.map((industry, idx) => (
    <button
      key={idx}
      className={`btn p-2 ${
        selected === industry.name
          ? "btnn-gradiant"
          : "btn-outline-secondary bg-light"
      }`}
      onClick={() => setSelected(industry.name)}
      style={{
        fontSize: "14px",
        fontWeight: "500",
        borderRadius: "10px",
        border: "none",
        width: "200px"
      }}
    >
      {industry.name}
    </button>
  ))}
</div>

        {/* Content */}
        <div className="row align-items-start mt-4">
          {/* Left - Images */}
          <div className="col-12 col-md-6 d-flex flex-column gap-3 justify-content-center">
  {selectedIndustry.images ? (
    <>
      {/* First image full width */}
      <img
        src={selectedIndustry.images[0]}
        alt="Industry visual"
        className="rounded"
        style={{ width: "100%", maxHeight: "180px", objectFit: "cover" }}
      />

      {/* Bottom row with two images side by side */}
      <div className="d-flex gap-3" style={{ justifyContent: "center" }}>
        {[1, 2].map(i => (
          <img
            key={i}
            src={selectedIndustry.images[i]}
            alt="Industry visual"
            className="rounded"
            style={{ width: "48%", maxHeight: "180px", objectFit: "cover" }}
          />
        ))}
      </div>
    </>
  ) : (
    <div className="text-muted">[Images will display here]</div>
  )}
</div>


          {/* Right - Description */}
          <div className="col-12 col-md-6 mt-4 mt-md-0">
            <div
              className="p-4 bg-light shadow-sm"
              style={{ borderRadius: "16px", minHeight: "250px" }}
            >
              <h5 className="fw-bold mb-2">{selectedIndustry.name}</h5>
              <p className="text-dark" style={{ fontWeight: "400", fontSize: "15px" }}>
                {selectedIndustry.content}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustriesWeServe;
